import React, { Component } from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from '../../Loader';

class Create extends Component {
	render() {
		let { AppConfig, actions } = this.props;

		let {
			isLoadingAction,

			showsNotif_form_dailyNotif_hh,
			showsNotif_form_dailyNotif_mm,
			showsNotif_form_dailyNotif_ss,
		} = AppConfig;

		let requiredSpan = <span style={{ color: 'red' }}>*</span>;

		return (
			<form>
				<Loader loading={isLoadingAction} />
				<Row>
					<Col md={6}>
						<ControlLabel>Hour {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<FormGroup>
							<FormControl
								type="number"
								value={showsNotif_form_dailyNotif_hh}
								onChange={(e) => {
									actions.setValue({
										showsNotif_form_dailyNotif_hh: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<ControlLabel>Minute {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<FormGroup>
							<FormControl
								type="number"
								value={showsNotif_form_dailyNotif_mm}
								onChange={(e) => {
									actions.setValue({
										showsNotif_form_dailyNotif_mm: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<ControlLabel>Second {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<FormGroup>
							<FormControl
								type="number"
								value={showsNotif_form_dailyNotif_ss}
								onChange={(e) => {
									actions.setValue({
										showsNotif_form_dailyNotif_ss: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
			</form>
		);
	}
}

function mapStateToProps(state) {
	let { AppConfig } = state;

	return {
		AppConfig,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/AppConfig/FormContainer/ShowsNotifForm.js